import Link from 'next/link'
import React from 'react'

interface VideoCustom {
    href: string,
}

interface LinkCustom {
    href: string,
    title: string,
    link: string
}

export const Video = ({href} : VideoCustom) => {
  return (
    <div className='flex justify-center'>
        <video className='w-4/5 desktop:w-2/3' controls autoPlay={true} muted playsInline={true}><source src={href}/></video>
    </div>
  )
}


export const LinkVideo = ({href,link,title} : LinkCustom) => {
  return (
    <div className='w-full flex items-center justify-center'>
      <section className=' w-4/5 laptop:w-3/5 flex justify-center items-center pb-7 text-white hover:text-navigation'>
          <Link className='flex justify-center items-center hover:opacity-80 ' href='/portfolio'>
              <video className='' id='video'muted autoPlay={true} loop playsInline={true}>
                  <source src={href} />
              </video>
          </Link>
          <Link className='absolute text-3xl laptop:text-4xl capitalize' href={link}>
              {title}
          </Link>
      </section>
    </div>
  )
}
